import { ReactComponent as CheckDefIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckFillIcon } from "assets/images/icons/checkbox_fiilled.svg";

import React, { useEffect, useState } from 'react';
import { TableRow, TableCell, Checkbox, TextField } from '@mui/material';
import MacAddressInputField from "components/InputField/MacAddressInputField";

const MacAddressTableRow = ({
  originalMacAddresses,
  mac,
  form,
  index,
  disabled,
  onMacChange,
  onDescChange,
  isSelected,
  onSelect,
}) => {
  const [error, setError] = useState(false);

  const checkDuplicateMac = (macAddress) => {
    const upperMac = macAddress.toUpperCase();
    const duplicate = originalMacAddresses.filter((item) => item.macAddress.toUpperCase() === upperMac);
    return duplicate.length > 1;
  }

  useEffect(() => {
    const v = mac.macAddress.toUpperCase();
    setError(!form.validateMacAddress(v) || checkDuplicateMac(v));
  }, [mac.macAddress, form]);

  return (
    <TableRow>
      {
        !disabled && (
          <>
            <TableCell>
              <Checkbox
                icon={<CheckDefIcon width='25px' height='25px' />}
                checkedIcon={<CheckFillIcon width='25px' height='25px' />}
                indeterminateIcon={<CheckDefIcon width='25px' height='25px' />}
                checked={isSelected}
                onChange={() => onSelect(index)}
                disabled={disabled}
              />
            </TableCell>
          </>
        )
      }
      <TableCell sx={{ width: "400px" }}>
        <MacAddressInputField
          value={mac.macAddress}
          onChange={(newVal) => {
            onMacChange(index, "macAddress", newVal);
            const v = newVal.toUpperCase();
            setError(!form.validateMacAddress(v));
          }}
          disabled={disabled}
          showError={error}
        />
      </TableCell>
      <TableCell sx={{ width: "400px" }}>
        <TextField
          value={mac.description}
          sx={{ ...form.getTextfieldStyle(true) }}
          fullWidth
          disabled={disabled}
          onChange={(e) => onDescChange(index, "description", e.target.value)}
        />
      </TableCell>
    </TableRow>
  );
}

export default React.memo(MacAddressTableRow);
